import React from 'react'
import { Columns } from '../../../../components/elements'
import './locationMap.css'
import ProfileMap from './../../map/listingMap.js'

const LocationMap = (props) => {
  const { isMobile } = props
  return (
    <Columns>
      <Columns.Column>
        <div className="location-main-container">
          <div className='is-flex is-align-items-center'>
            <h1 className="bike-profile-subHeading mb-5">Location</h1>
            <i class="fa-solid fa-location-dot ml-2 mb-5"></i>
          </div>
          {props.bikeData && (
            <div className="map-container">
              <ProfileMap
                latitude={props.bikeData?.bike_location?.search_latitude}
                longitude={props.bikeData?.bike_location?.search_longitude}
                isMobile={isMobile}
                city={props.bikeData?.bike_location?.location_city}
              />
            </div>
          )}
        </div>
      </Columns.Column>
    </Columns>
  )
}

export default LocationMap
